import React from "react";

export default function Error(){

    return (
        <>
        aqui hubo un error
        </>
    )
}